/* BRAVER · Lente completo en el carro
   Mantiene unidas las dos líneas que agrega el flujo de cristales (armazón + cristales),
   enlazadas por la propiedad oculta _lente_completo:
   - Los cristales no tienen botones propios de cantidad ni de eliminar: siguen al armazón.
   - Si se elimina el armazón, se eliminan sus cristales.
   - Si cambia la cantidad del armazón, los cristales se igualan.
   - Si quedara un armazón sin sus cristales, se le quita la etiqueta "Lente completo". */
(function () {
  if (window.__bcrPair) return; window.__bcrPair = true;
  var REF = '_lente_completo', busy = false, onCart = location.pathname === '/cart' || location.pathname === '/cart/';

  function isLens(i) { return i.properties && i.properties[REF] && i.properties['Armazón']; }
  function isFrame(i) { return i.properties && i.properties[REF] && !i.properties['Armazón']; }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(body) { return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }

  function plan(cart) {
    var g = {}, ops = [];
    cart.items.forEach(function (i) { var r = i.properties && i.properties[REF]; if (!r) return; (g[r] = g[r] || { f: [], l: [] })[isLens(i) ? 'l' : 'f'].push(i); });
    Object.keys(g).forEach(function (r) {
      var f = g[r].f[0], ls = g[r].l;
      if (!f) { ls.forEach(function (l) { ops.push({ id: l.key, quantity: 0 }); }); return; }
      if (!ls.length) { var p = {}; Object.keys(f.properties).forEach(function (k) { if (k !== REF && k !== 'Lente completo') p[k] = f.properties[k]; }); ops.push({ id: f.key, quantity: f.quantity, properties: p }); return; }
      ls.forEach(function (l) { if (l.quantity !== f.quantity) ops.push({ id: l.key, quantity: f.quantity }); });
    });
    return ops;
  }

  function reconcile() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      var ops = plan(cart);
      if (!ops.length) { busy = false; mark(cart); return false; }
      return ops.reduce(function (p, op) { return p.then(function () { return change(op); }); }, Promise.resolve()).then(function () {
        busy = false;
        if (onCart) location.reload(); else getCart().then(mark);
        return true;
      });
    }).catch(function () { busy = false; return false; });
  }

  /* Marca en pantalla las líneas de cristales: sin cantidad ni eliminar propios. */
  var lensKeys = {};
  function mark(cart) {
    if (cart) { lensKeys = {}; cart.items.forEach(function (i) { if (isLens(i)) lensKeys[i.key] = true; }); }
    document.querySelectorAll('[item-key]').forEach(function (el) {
      var on = !!lensKeys[el.getAttribute('item-key')];
      el.classList.toggle('bcr-lens-line', on);
      if (on && !el.querySelector('.bcr-lens-note')) {
        el.querySelectorAll('.cartItem__quantity').forEach(function (q) {
          var n = document.createElement('p'); n.className = 'bcr-lens-note'; n.textContent = 'Va con tu armazón';
          q.parentNode.insertBefore(n, q);
        });
      }
    });
  }
  var css = document.createElement('style');
  css.textContent = '.bcr-lens-line quantity-selector,.bcr-lens-line .product-quantity__selector-wrapper,.bcr-lens-line .remove__lineItem{display:none!important}' +
    '.bcr-lens-note{margin:0;font-size:12px;line-height:1.3;color:#6b6b6b;white-space:nowrap}';
  document.head.appendChild(css);

  /* Después de cualquier cambio del carro hecho por el tema, revisa el par. */
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (url.indexOf('/cart/change') >= 0 || url.indexOf('/cart/update') >= 0) p.then(function () { setTimeout(reconcile, 150); }, function () {});
    return p;
  };

  if (onCart) {
    reconcile();
    new MutationObserver(function () { mark(); }).observe(document.body, { childList: true, subtree: true });
  }
})();